import { render, staticRenderFns } from "./loginToken.vue?vue&type=template&id=5c0b5ed1&"
import script from "./loginToken.vue?vue&type=script&lang=js&"
export * from "./loginToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports